import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import * as jspdf from 'jspdf';

import html2canvas from 'html2canvas';
import { HttpService } from '../../../services/http/http.service';
import { LocalstorageService } from '../../../services/localstorage/localstorage.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { PlatformLocation } from '@angular/common';

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss']
})
export class ResultComponent implements OnInit {
  @ViewChild('downloadLink') downloadLink: ElementRef;
  @ViewChild('canvas') canvas: ElementRef;
  campaignId;
  userName =  localStorage.getItem('user')
  downloadResult = false;
  marks = "0";
  attemptCount = 0;
  percentage;
  response;
  result: string = (localStorage.getItem('result'));
  percent = parseInt(localStorage.getItem('percent'));
  retryButtonFlag = localStorage.getItem('checkValue');
  passingPercentage=parseInt(localStorage.getItem('per'))
  maxcount=localStorage.getItem('maxCount')
  count: any;
  constructor(private router: Router,
    private httpService: HttpService, private localstorageService: LocalstorageService,
    private spinnerService: Ng4LoadingSpinnerService, location1: PlatformLocation) {
    location1.onPopState(() => {
      // history.pushState( null, null,"");
      //  history.pushState(null, null,"/result");
      window.history.go(1);
      // this.backPressed = true;
      // console.log('pressed back! : ', this.backPressed);
      // this.getAllQuestions();
      return false;

    });

  }

  ngOnInit() {
    this.campaignId = localStorage.getItem('campaignId');
   // this.response = this.httpService.getResponse();
   this.response = JSON.parse(localStorage.getItem('Response'));
    this.localstorageService.setData("examStarted", "0");
    history.pushState(null, null, location.href);

    this.getResultData();
    // this.result = Math.round((parseInt(localStorage.getItem('result'))));
    this.userName = localStorage.getItem('user');
  }

  getResultData() {
    console.log("response", this.response);

    
    console.log("Attempt Count Test:-",this.response.data.attemptCount)
    this.count=this.response.data.attemptCount;

    if(this.response !== undefined){
      this.percentage = Math.round((parseInt(this.response.data.marks) / parseInt(this.response.data.totalMarks)) * 100);
   
    }else{
      this.percentage = localStorage.getItem('percentage');
    }
  
    localStorage.setItem('name',this.userName);
    localStorage.setItem('percentage',this.percentage);
    localStorage.setItem('campaignId',this.campaignId);
  
  }

  retryTest() {
    this.router.navigate(['test']);
  }

  shareResult() {
    this.downloadResult = true;
    var data = document.getElementById('contentToConvert');
    html2canvas(data).then(canvas => {
      this.canvas.nativeElement.src = canvas.toDataURL();
      this.downloadLink.nativeElement.href = canvas.toDataURL('image/jpeg');
      this.downloadLink.nativeElement.download = 'result.jpeg';
      
      this.downloadLink.nativeElement.click();
      this.downloadResult = false;
    });

  }


}
